import { Guid } from '@web/utils';

export class PublicBoxCategory {
  public constructor(
    public readonly id: Guid,
    public readonly slug: string,
    public readonly name: string,
    public readonly numberOfBoxes: number,
  ) {}
}
